angular.module("dx.webapp.node").constant("DX_NODE_IMAGES", Object.freeze({
	PROFILE: "img/default-profile.png",
	COVER: "img/default-cover.jpg",
}));
